import { ISelectOption, IBooleanAsString } from '../types/ui'
import {
	EAccountIsActive,
	EOfferScopeCapType,
	EOfferScopeStatus,
	ERoleAccessIsAny,
	ERoleIsSystem,
	ERoleExtraIsBuyer,
	EHistoryIsEmpty,
	ERevenueAgencyFakeType,
	EDatePickerMode,
	EPostbackStatus,
	EPostbackCurrency,
	EPercentIsEmpty,
	EAccountIsFired,
	DATE_PICKER_MODE_LABEL_MAP,
	POSTBACK_CURRENCY_LABEL_MAP,
	OFFER_SCOPE_STATUS_LABEL_MAP,
	OFFER_SCOPE_CAP_TYPE_LABEL_MAP,
	HISTORY_IS_EMPTY_LABEL_MAP,
	POSTBACK_STATUS_LABEL_MAP,
	REVENUE_AGENCY_FAKE_TYPE_LABEL_MAP,
	ACCOUNT_IS_ACTIVE_LABEL_MAP,
	ROLE_EXTRA_IS_BUYER_LABEL_MAP,
	ROLE_IS_SYSTEM_LABEL_MAP,
	ROLE_ACCESS_IS_ANY_LABEL_MAP,
	PERCENT_IS_EMPTY_LABEL_MAP,
	ACCOUNT_IS_FIRED_LABEL_MAP
} from '../types'
import { CapTypeIcon, RoleExtraIsBuyerIcon, CheckBoxStatusIcon, IconHistory } from '../components/ui'
import { STATUS_COLORS_MAP } from './constant.statusColorsMap'
import { ACCESS_IS_ANY_COLORS_MAP } from './constant.accessIsAnyColorsMap'
import { IS_ACTIVE_COLORS_MAP } from './constant.isActiveColorsMap'
import { REVENUE_AGENCY_FAKE_TYPE_COLORS_MAP } from './constant.revenueAgencyFakeTypeColorsMap'
import { POSTBACK_STATUS_COLORS_MAP } from './constant.postbackStatusColorsMap'
import { ACCOUNT_IS_FIRED_COLORS_MAP } from './constant.accountIsFiredColorsMap'
import { TFunction } from 'react-i18next'


export const OFFER_SCOPE_CAP_TYPE_OPTIONS = (
	t: TFunction
): ISelectOption<EOfferScopeCapType>[] => Object.entries(EOfferScopeCapType).map(([key, value]) => {
	const keyTrans = OFFER_SCOPE_CAP_TYPE_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)

	return (
		{
			value,
			label: (
				<div><CapTypeIcon value={value}/> {labelTrans}</div>
			)
		}
	)
})

export const OFFER_SCOPE_STATUS_OPTIONS = (
	t: TFunction
): ISelectOption<EOfferScopeStatus>[] => Object.entries(EOfferScopeStatus).map(([key, value]) => {
	const keyTrans = OFFER_SCOPE_STATUS_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)

	return (
		{
			value,
			label: (
				<span
					className={`badge text-white fw-normal py-1 px-2 fs-12 rounded-1 edit ${STATUS_COLORS_MAP?.[value]}`}
				>
					{labelTrans}
				</span>
			)
		}
	)
})

export const ROLE_IS_SYSTEM_OPTIONS = (
	t: TFunction
): ISelectOption<IBooleanAsString>[] => Object.entries(ERoleIsSystem).map(([key, value]) => {
	const keyTrans = ROLE_IS_SYSTEM_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)
	// special converting (booleanToString) because react-select works only with 'string' data
	const convertValue = value === ERoleIsSystem.System
	const convertValueFormat = convertValue.toString()

	return (
		{
			value: convertValueFormat,
			label: (
				<div><CheckBoxStatusIcon value={convertValue} iconCheckColor={'--dangerColor'}/> {labelTrans}</div>
			)
		}
	)
})

export const ROLE_ACCESS_IS_ANY_OPTIONS = (
	t: TFunction
): ISelectOption<ERoleAccessIsAny>[] => Object.entries(ERoleAccessIsAny).map(([key, value]) => {
	const keyTrans = ROLE_ACCESS_IS_ANY_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)

	return (
		{
			value,
			label: (
				<span
					className={`badge text-white fw-normal py-1 px-2 fs-12 rounded-1 edit ${ACCESS_IS_ANY_COLORS_MAP?.[value]}`}
				>
					{labelTrans}
				</span>
			)
		}
	)
})

export const ACCOUNT_IS_ACTIVE_OPTIONS = (
	t: TFunction
): ISelectOption<IBooleanAsString>[] => Object.entries(EAccountIsActive).map(([key, value]) => {
	const keyTrans = ACCOUNT_IS_ACTIVE_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)
	// special converting (booleanToString) because react-select works only with 'string' data
	const convertValue = value === EAccountIsActive.active
	const convertValueFormat = convertValue.toString()

	return (
		{
			value: convertValueFormat,
			label: (
				<span
					className={`badge text-white fw-normal py-1 px-2 fs-12 rounded-1 edit ${IS_ACTIVE_COLORS_MAP?.[value]}`}
				>
					{labelTrans}
				</span>
			)
		}
	)
})

export const ACCOUNT_IS_FIRED_OPTIONS = (
	t: TFunction
): ISelectOption<IBooleanAsString>[] => Object.entries(EAccountIsFired).map(([key, value]) => {
	const keyTrans = ACCOUNT_IS_FIRED_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)
	// special converting (booleanToString) because react-select works only with 'string' data
	const convertValue = value === EAccountIsFired.Fired
	const convertValueFormat = convertValue.toString()

	return (
		{
			value: convertValueFormat,
			label: (
				<span
					className={`badge text-white fw-normal py-1 px-2 fs-12 rounded-1 edit ${ACCOUNT_IS_FIRED_COLORS_MAP?.[value]}`}
				>
					{labelTrans}
				</span>
			)
		}
	)
})

export const ROLE_EXTRA_IS_BUYER_OPTIONS = (
	t: TFunction
): ISelectOption<IBooleanAsString>[] => Object.entries(ERoleExtraIsBuyer).map(([key, value]) => {
	const keyTrans = ROLE_EXTRA_IS_BUYER_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)
	// special converting (booleanToString) because react-select works only with 'string' data
	const convertValue = value === ERoleExtraIsBuyer.Buyer ? 'true' : 'false'

	return (
		{
			value: convertValue,
			label: (
				<div><RoleExtraIsBuyerIcon value={value}/> {labelTrans}</div>
			)
		}
	)
})

export const HISTORY_IS_EMPTY_OPTIONS = (
	t: TFunction
): ISelectOption<IBooleanAsString>[] => Object.entries(EHistoryIsEmpty).map(([key, value]) => {
	const keyTrans = HISTORY_IS_EMPTY_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)
	// special converting (booleanToString) because react-select works only with 'string' data
	const convertValue = value === EHistoryIsEmpty.Empty
	const convertValueFormat = convertValue.toString()
	const fillColor = !convertValue ? 'var(--successColor, black)' : 'black'

	return (
		{
			value: convertValueFormat,
			label: (
				<div><IconHistory fill={fillColor}/> {labelTrans}</div>
			)
		}
	)
})

export const PERCENT_IS_EMPTY_OPTIONS = (
	t: TFunction
): ISelectOption<IBooleanAsString>[] => Object.entries(EPercentIsEmpty).map(([key, value]) => {
	const keyTrans = PERCENT_IS_EMPTY_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)
	// special converting (booleanToString) because react-select works only with 'string' data
	const convertValue = value === EPercentIsEmpty.Empty
	const convertValueFormat = convertValue.toString()

	return (
		{
			value: convertValueFormat,
			label: labelTrans
		}
	)
})

export const REVENUE_AGENCY_FAKE_TYPE_OPTIONS = (
	t: TFunction
): ISelectOption<ERevenueAgencyFakeType>[] => Object.entries(ERevenueAgencyFakeType).map(([key, value]) => {
	const keyTrans = REVENUE_AGENCY_FAKE_TYPE_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)

	return (
		{
			value,
			label: (
				<span
					className={`badge text-white fw-normal py-1 px-2 fs-12 rounded-1 edit ${REVENUE_AGENCY_FAKE_TYPE_COLORS_MAP?.[value]}`}
				>
					{labelTrans}
				</span>
			)
		}
	)
})

export const DATE_PICKER_MODE_OPTIONS = (
	t: TFunction
): ISelectOption<EDatePickerMode>[] => Object.entries(EDatePickerMode).map(([key, value]) => {
	const keyTrans = DATE_PICKER_MODE_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)

	return (
		{
			value,
			label: labelTrans
		}
	)
})

export const POSTBACK_STATUS_OPTIONS = (
	t: TFunction
): ISelectOption<EPostbackStatus>[] => Object.entries(EPostbackStatus).map(([key, value]) => {
	const keyTrans = POSTBACK_STATUS_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)

	return (
		{
			value,
			label: (
				<span
					className={`badge text-white fw-normal py-1 px-2 fs-12 rounded-1 edit ${POSTBACK_STATUS_COLORS_MAP?.[value]}`}
				>
					{labelTrans}
				</span>
			)
		}
	)
})

export const POSTBACK_CURRENCY_OPTIONS = (
	t: TFunction
): ISelectOption<EPostbackCurrency>[] => Object.entries(EPostbackCurrency).map(([key, value]) => {
	const keyTrans = POSTBACK_CURRENCY_LABEL_MAP?.[value]
	const labelTrans = t(keyTrans)

	return (
		{
			value,
			label: (
				<span>
					{labelTrans}
				</span>
			)
		}
	)
})
